import { render, staticRenderFns } from "./TeachOtoComment.vue?vue&type=template&id=89f2618a&scoped=true&"
import script from "./TeachOtoComment.vue?vue&type=script&lang=js&"
export * from "./TeachOtoComment.vue?vue&type=script&lang=js&"
import style0 from "./TeachOtoComment.vue?vue&type=style&index=0&id=89f2618a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f2618a",
  null
  
)

export default component.exports